const article = "_j0ja140c0ve";
const wrapper = "_j0jwvv68np";
const container = "_j0jc1bw6pt";
const slider = "_j0js1a43yyk";
const navButton = "_j0jnihizvf";
const allLink = "_j0ja1fj8icq";

export { allLink, article, container, navButton, slider, wrapper };
import "./slider.style.linaria.module.css";
//# sourceMappingURL=slider.style.js.map
